import "core-js/modules/es.array.unshift.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0502e96e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "kline-chart",
  style: {
    "height": "80vh"
  }
}, null, -1));
import { onMounted, onBeforeUnmount, ref } from 'vue';
import axios from 'axios';
import { dispose, init } from 'klinecharts';
import { message } from 'ant-design-vue';
import 'ant-design-vue/es/message/style/css';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { reactive } from 'vue';
export default {
  __name: 'HomeView',
  setup(__props) {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    var token_date = new Date();
    let token_data = token_date.getFullYear() + '-' + (token_date.getMonth() + 1) + '-' + token_date.getDate();
    const timeArr = [60, 300, 900, 1800, 3600, 14400, 86400, 604800];
    const timeIndex = ref(0);
    const apiHost = "https://xmwsapi.tokec.com/kline";
    let dataLen = 0;
    let klineMoreTimes = 1;
    let curr_time_done = true;
    console.log(dataLen);
    const timeSelect = index => {
      startIndex.value = -2;
      updateIndex.value = -1;
      dataArr.value = [];
      dataLen = 0;
      loading.value = true;
      axios.post(apiHost + "/api/history_kline?token=" + token_data, {
        symbol: marketList.value[form.market].symbol,
        interval: timeArr[index],
        times: 1
      }).then(res => {
        if (res.status !== 200 || res.data.code !== 200) {
          message.error("数据请求失败");
          return;
        }
        timeIndex.value = index;
        klineMoreTimes = 1;
        if (res.data.data.kline.length > 0) {
          isClick.value = true;
          chart.setPriceVolumePrecision(marketList.value[form.market].decimal);
          step.value = Number(Math.pow(10, -marketList.value[form.market].decimal).toFixed(8));
          limitHigh.value = Number(form.high);
          limitLow.value = Number(form.low);
          for (const key of Object.keys(res.data.data.kline.reverse())) {
            dataLen++;
            res.data.data.kline[key] = typeof res.data.data.kline[key] == 'string' ? res.data.data.kline[key].split(",") : res.data.data.kline[key];
            const itemArray = {
              timestamp: Number(res.data.data.kline[key][0] * 1000),
              open: Number(res.data.data.kline[key][1]),
              high: Number(res.data.data.kline[key][3]),
              low: Number(res.data.data.kline[key][4]),
              close: Number(res.data.data.kline[key][2]),
              volume: Number(res.data.data.kline[key][5])
            };
            dataArr.value.unshift(itemArray);
          }
          console.log(dataArr);
          dataLen -= 1;
          newData();
        } else {
          dataArr.value = [];
          chart.applyNewData(dataArr.value, false);
          chart.scrollToDataIndex(updateIndex.value, 0.8);
          // chart.clearData()
        }
      }).finally(() => {
        loading.value = false;
        initLoading.value = false;
        currTime();
      });
    };
    const step = ref(0.01);
    const limitHigh = ref(0);
    const limitLow = ref(0);
    const marketChange = market => {
      startIndex.value = -2;
      loading.value = true;
      initLoading.value = true;
      axios.post(apiHost + "/api/history_kline?token=" + token_data, {
        symbol: marketList.value[market].symbol,
        interval: 60,
        times: 1
      }).then(res => {
        if (res.status !== 200 || res.data.code !== 200) {
          message.error("数据请求失败");
          return;
        }
        klineMoreTimes = 1;
        timeIndex.value = 0;
        dataArr.value = [];
        chart.applyNewData(dataArr.value, false);
        chart.scrollToDataIndex(updateIndex.value, 0.8);
        if (res.data.data.kline.length > 0) {
          isClick.value = true;
          chart.setPriceVolumePrecision(marketList.value[market].decimal);
          step.value = Number(Math.pow(10, -marketList.value[market].decimal).toFixed(8));
          limitHigh.value = Number(form.high);
          limitLow.value = Number(form.low);
          for (const key of Object.keys(res.data.data.kline.reverse())) {
            dataLen++;
            res.data.data.kline[key] = res.data.data.kline[key].split(",");
            const itemArray = {
              timestamp: Number(res.data.data.kline[key][0] * 1000),
              open: Number(res.data.data.kline[key][1]),
              high: Number(res.data.data.kline[key][3]),
              low: Number(res.data.data.kline[key][4]),
              close: Number(res.data.data.kline[key][2]),
              volume: Number(res.data.data.kline[key][5])
            };
            dataArr.value.unshift(itemArray);
          }
          dataLen -= 1;
          newData();
        } else {
          // chart.clearData()
        }
      }).finally(() => {
        loading.value = false;
        initLoading.value = false;
        currTime();
      });
    };
    const updateIndex = ref(-1);
    const startIndex = ref(-2);
    let chart = null;
    const klineInit = () => {
      chart = init('kline-chart', {
        styles: {
          candle: {
            tooltip: {
              showRule: 'follow_cross',
              showType: 'rect'
            }
          }
        }
      });
      chart.setTimezone('America/New_York');
      chart.setOffsetRightDistance(20);
      chart.createIndicator({
        name: 'VOL',
        calcParams: [10],
        styles: {
          margin: {
            top: 0.2,
            bottom: 2
          }
        }
      });
      chart.createIndicator({
        name: 'MA',
        shortName: 'MA',
        calcParams: [10, 20, 30],
        dragEnabled: true,
        plots: [{
          key: 'ma1',
          title: 'MA10: ',
          type: 'line'
        }, {
          key: 'ma2',
          title: 'MA20: ',
          type: 'line'
        }, {
          key: 'ma3',
          title: 'MA30: ',
          type: 'line'
        }],
        regeneratePlots: params => {
          return params.map((p, i) => {
            return {
              key: `ma${i + 1}`,
              title: `MA${p}: `,
              type: 'line'
            };
          });
        }
      }, true, {
        id: 'candle_pane',
        dragEnabled: true
      });
      // chart.subscribeAction('onCandleBarClick', selectKline)
      chart.loadMore(klineMore);
    };
    const klineMore = timestamp => {
      console.log(timestamp);
      loading.value = true;
      klineMoreTimes++;
      axios.post(apiHost + "/api/history_kline?token=" + token_data, {
        symbol: marketList.value[form.market].symbol,
        interval: timeArr[timeIndex.value],
        times: klineMoreTimes
      }).then(res => {
        if (res.status !== 200 || res.data.code !== 200) {
          message.error("数据请求失败");
          return;
        }
        if (res.data.data.kline.length > 0) {
          let dataArrMore = [];
          for (const key of Object.keys(res.data.data.kline.reverse())) {
            dataLen++;
            res.data.data.kline[key] = typeof res.data.data.kline[key] == 'string' ? res.data.data.kline[key].split(",") : res.data.data.kline[key];
            const itemArray = {
              timestamp: Number(res.data.data.kline[key][0] * 1000),
              open: Number(res.data.data.kline[key][1]),
              high: Number(res.data.data.kline[key][3]),
              low: Number(res.data.data.kline[key][4]),
              close: Number(res.data.data.kline[key][2]),
              volume: Number(res.data.data.kline[key][5])
            };
            dataArrMore.unshift(itemArray);
          }
          dataLen -= 1;
          chart.applyMoreData(dataArrMore, dataArrMore.length > 0 ? true : false);
          if (!curr_time_done) currTime();
        }
      }).finally(() => {
        loading.value = false;
        currTime();
      });
    };
    const newData = () => {
      chart.applyNewData(dataArr.value, true);
      if (updateIndex.value > -1) {
        chart.scrollToDataIndex(updateIndex.value, 0.8);
      }
    };
    const currTime = () => {
      var tt = Date.now();
      tt = parseInt(tt / 1000 / timeArr[timeIndex.value]) * timeArr[timeIndex.value] * 1000;
      chart.scrollToTimestamp(tt, 500);
      if (chart.getDataList()[0].timestamp > tt) {
        curr_time_done = false;
      } else curr_time_done = true;
    };
    let dataArr = ref([]);
    const loading = ref(false);
    const form = reactive({
      market: null,
      time: null,
      open: 0,
      close: 0,
      high: 0,
      low: 0,
      volumeOpen: 0,
      volumeClose: 0,
      volumeHigh: 0,
      volumeLow: 0
    });
    const isClick = ref(false);
    const marketList = ref([]);
    const initLoading = ref(true);
    onMounted(() => {
      klineInit();
      axios.get(apiHost + "/api/preview_info?t=2&token=" + token_data).then(res => {
        if (res.status !== 200 || res.data.code !== 200) {
          message.error(res.data.message || "数据请求失败");
          return;
        }
        const data = res.data.data;
        marketList.value = data?.map((item, index) => {
          return {
            index: index,
            symbol: item.market_symbol,
            marketId: item.id,
            decimal: item.decimal_num
          };
        });
      }).finally(() => {
        initLoading.value = false;
      });
    });
    onBeforeUnmount(() => {
      dispose('kline-chart');
    });
    return (_ctx, _cache) => {
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_layout = _resolveComponent("a-layout");
      const _component_a_layout_content = _resolveComponent("a-layout-content");
      return _openBlock(), _createBlock(_component_a_layout, null, {
        default: _withCtx(() => [_createVNode(_component_a_layout, {
          style: {
            "width": "600px",
            "padding": "10px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_spin, {
            spinning: initLoading.value
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_form_item, {
              name: "market",
              label: "K线预览-市场",
              style: {
                "width": "450px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_a_select, {
                value: form.market,
                "onUpdate:value": _cache[0] || (_cache[0] = $event => form.market = $event),
                onChange: marketChange
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(marketList.value, item => {
                  return _openBlock(), _createBlock(_component_a_select_option, {
                    key: item.marketId,
                    value: item.index
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.symbol), 1)]),
                    _: 2
                  }, 1032, ["value"]);
                }), 128))]),
                _: 1
              }, 8, ["value"])]),
              _: 1
            }), isClick.value ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              style: {
                "margin-left": "15px"
              },
              onClick: currTime
            }, {
              default: _withCtx(() => [_createTextVNode("当前时间")]),
              _: 1
            })) : _createCommentVNode("", true)])]),
            _: 1
          }, 8, ["spinning"])]),
          _: 1
        }), _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [_createVNode(_component_a_layout_content, {
            class: "kline-update"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_spin, {
              size: "large",
              spinning: loading.value
            }, {
              default: _withCtx(() => [isClick.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_a_button, {
                type: timeIndex.value === 0 ? 'primary' : '',
                onClick: _cache[1] || (_cache[1] = $event => timeSelect(0)),
                style: {
                  "margin-right": "20px"
                }
              }, {
                default: _withCtx(() => [_createTextVNode("1分钟")]),
                _: 1
              }, 8, ["type"]), _createVNode(_component_a_button, {
                type: timeIndex.value === 1 ? 'primary' : '',
                onClick: _cache[2] || (_cache[2] = $event => timeSelect(1)),
                style: {
                  "margin-right": "20px"
                }
              }, {
                default: _withCtx(() => [_createTextVNode("5分钟")]),
                _: 1
              }, 8, ["type"]), _createVNode(_component_a_button, {
                type: timeIndex.value === 2 ? 'primary' : '',
                onClick: _cache[3] || (_cache[3] = $event => timeSelect(2)),
                style: {
                  "margin-right": "20px"
                }
              }, {
                default: _withCtx(() => [_createTextVNode("15分钟")]),
                _: 1
              }, 8, ["type"]), _createVNode(_component_a_button, {
                type: timeIndex.value === 3 ? 'primary' : '',
                onClick: _cache[4] || (_cache[4] = $event => timeSelect(3)),
                style: {
                  "margin-right": "20px"
                }
              }, {
                default: _withCtx(() => [_createTextVNode("30分钟")]),
                _: 1
              }, 8, ["type"]), _createVNode(_component_a_button, {
                type: timeIndex.value === 4 ? 'primary' : '',
                onClick: _cache[5] || (_cache[5] = $event => timeSelect(4)),
                style: {
                  "margin-right": "20px"
                }
              }, {
                default: _withCtx(() => [_createTextVNode("1小时")]),
                _: 1
              }, 8, ["type"]), _createVNode(_component_a_button, {
                type: timeIndex.value === 5 ? 'primary' : '',
                onClick: _cache[6] || (_cache[6] = $event => timeSelect(5)),
                style: {
                  "margin-right": "20px"
                }
              }, {
                default: _withCtx(() => [_createTextVNode("4小时")]),
                _: 1
              }, 8, ["type"]), _createVNode(_component_a_button, {
                type: timeIndex.value === 6 ? 'primary' : '',
                onClick: _cache[7] || (_cache[7] = $event => timeSelect(6)),
                style: {
                  "margin-right": "20px"
                }
              }, {
                default: _withCtx(() => [_createTextVNode("天")]),
                _: 1
              }, 8, ["type"]), _createVNode(_component_a_button, {
                type: timeIndex.value === 7 ? 'primary' : '',
                onClick: _cache[8] || (_cache[8] = $event => timeSelect(7)),
                style: {
                  "margin-right": "20px"
                }
              }, {
                default: _withCtx(() => [_createTextVNode("周")]),
                _: 1
              }, 8, ["type"])])) : _createCommentVNode("", true), _hoisted_3]),
              _: 1
            }, 8, ["spinning"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};